import React, { useEffect } from 'react'
import Navbar from '../../Components/Navbar'
import RecipeSelector from './components/RecipeSelector'
import { useRecipesHook } from '../../Hooks/communicators/useRecipesHook'
import { useSelector } from 'react-redux';
import { useNavigationHook } from '../../Hooks/useNavigationHook';

export default function Recipes() {
    const { returnSelectedRecipePage } = useRecipesHook();
    const {
        accessToken,
        refreshToken,
        UID,
    } = useSelector((state: any) => state.auth.value);
    const {
        navigateTo
    } = useNavigationHook();

    const checkAuth = () => {
        if (accessToken === '' || refreshToken === '' || UID === '') {
            navigateTo('/');
        };
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <div className='flex justify-center items-center flex-col'>
            <Navbar />
            <RecipeSelector />
            {returnSelectedRecipePage()}
        </div>
    )
}
